/* asset loading — Dolo frame sets, legacy sprite, backdrop, worm tier art, banner, crow flight cycle, beast charge strips, boss worm art */
import { BEAST_ART, BOSS_WORMS, WORM_TIERS } from "./constants";

export function loadGameAssets({ doloRef, spriteRef, wormsRef, bannerRef, crowRef, bgRef, stateRef, beastRef, bossRef }) {
    // boombox-gunner sprite set (user-supplied frames, white-keyed + trimmed)
    const mkFrame = (src) => {
      const img = new Image();
      img.src = src;
      return img;
    };
    doloRef.current = {
      run: [mkFrame("/assets/dolo-run-1.png"), mkFrame("/assets/dolo-run-2.png")],
      jump: mkFrame("/assets/dolo-jump.png"),
      fwd: [1, 2, 3, 4].map((i) => mkFrame(`/assets/dolo-shoot-fwd-${i}.png`)),
      back: [1, 2, 3, 4].map((i) => mkFrame(`/assets/dolo-shoot-back-${i}.png`)),
      slash: [1, 2, 3, 4].map((i) => mkFrame(`/assets/dolo-slash-${i}.png`)),
    };
    doloRef.current.run[0].onload = () => {
      stateRef.current.spriteReady = true;
    };
    const sprite = new Image();
    sprite.src = "/assets/dolo-runner-sprite.png";
    sprite.onload = () => {
      spriteRef.current = sprite;
      stateRef.current.spriteReady = true;
    };
    const bgArt = new Image();
    bgArt.src = "/assets/game-bg.jpg";
    bgArt.onload = () => {
      bgRef.current = bgArt;
    };
    WORM_TIERS.forEach((tier, i) => {
      const img = new Image();
      img.src = tier.src;
      img.onload = () => {
        wormsRef.current[i] = img;
      };
    });
    const banner = new Image();
    banner.src = "/assets/game-banner.jpg";
    banner.onload = () => {
      bannerRef.current = banner;
    };
    // mutated crow flight cycle — eight wing poses from the official sheet
    for (let i = 1; i <= 8; i += 1) {
      const img = new Image();
      img.onload = ((idx, el) => () => { crowRef.current[idx] = el; })(i - 1, img);
      img.src = `/assets/crow-fly-${i}.png`;
    }
    // charging mutant packs — wolf and horned-bear run cycles as single strips
    Object.entries(BEAST_ART).forEach(([kind, art]) => {
      const img = new Image();
      img.onload = () => { beastRef.current[kind] = img; };
      img.src = art.src;
    });
    // named boss worms — user-supplied artworks; the first two carry full pose sets
    // (idle/roar/attack/damage/death) and animate in the duel
    if (bossRef) {
      BOSS_WORMS.forEach((boss, i) => {
        if (boss.poses) {
          const set = {};
          bossRef.current[i] = set;
          Object.entries(boss.poses).forEach(([pose, src]) => {
            const img = new Image();
            img.onload = () => { set[pose] = img; };
            img.src = src;
          });
        } else {
          const img = new Image();
          img.onload = () => { bossRef.current[i] = img; };
          img.src = boss.src;
        }
      });
    }
}
